<template>
  <BaseWeb :logo-img="logoPhoto"
           :app-img-arr="appPhotoArr" :app-name="appName" :company="companyName" :icp-num="icpNum"
           class="many_recruit_btn" :download-path="downloadPath" :one-word="oneWord" :tow-word="towWord"></BaseWeb>
</template>

<script>
import BaseWeb from '../components/baseWeb'
export default {
  name: "partTimePackage",
  components:{
    BaseWeb:BaseWeb
  },
  data(){
    return{
      logoPhoto:require('../assets/partTimePackage/logo.jpg'),
      appPhotoArr:[
        {id:1,photo:require('../assets/partTimePackage/one.png')},
        {id:2,photo:require('../assets/partTimePackage/two.png')},
        {id:3,photo:require('../assets/partTimePackage/three.png')},
        {id:4,photo:require('../assets/partTimePackage/four.png')},
      ],
      appName:'兼职包',
      companyName:'杭州智甄科技有限公司',
      icpNum:'浙ICP备2021023395号-1',
      downloadPath:'http://apk.hotbuybuy.com/cmjz_oppo_100.apk',
      oneWord:'兼职包助力兼职常识必坑',
      towWord:'兼职包是一款兼职类答题软件，海量兼职题库，提升兼职意识，从小白快速提升至兼职大神。兼职包还是一款益智类答题软件，有着上千道题目等你来挑战，不仅有天文地理，人文历史，还有生活小常识等趣味题目噢。页面清爽整洁，让你尽情体验答题带来的思维盛宴，答题可获得经验升级，提升等级领取现金红包大奖！\n' +
        '应用亮点：答题就能得奖励',
    }
  }
}
</script>

<style scoped>
.many_recruit_btn{
  --downBtn:#fc5a67;
}
</style>



// WEBPACK FOOTER //
// src/components/partTimePackage.vue